// WhatsApp deep-link helpers (no API used — pure wa.me links).
export const WA_NUMBER = "917447555058";

export const buildWaUrl = (message) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

export const DEFAULT_WA_URL = buildWaUrl(
  "Hello, I am interested in Godavari Builders projects."
);

export const openWhatsApp = (message) => {
  const url = buildWaUrl(message);
  window.open(url, "_blank", "noopener,noreferrer");
};

// Build a rich, readable enquiry message from a form payload.
export const buildEnquiryMessage = ({ name, phone, email, interest, message }) => {
  const lines = [
    "*New Enquiry — Godavari Builders & Developers*",
    "",
    name ? `*Name:* ${name}` : null,
    phone ? `*Phone:* ${phone}` : null,
    email ? `*Email:* ${email}` : null,
    interest ? `*Interested In:* ${interest}` : null,
    message ? `*Message:* ${message}` : null,
  ].filter(Boolean);
  return lines.join("\n");
};
